module.exports = __webpack_public_path__ + "static/excluding8-5078ffa97e788719b84e57ed44e0706e.png";